import { render, staticRenderFns } from "./main-tutor-detail.html?vue&type=template&id=2cab827f&scoped=true&"
import script from "./main-tutor-detail.ts?vue&type=script&lang=ts&"
export * from "./main-tutor-detail.ts?vue&type=script&lang=ts&"
import style0 from "./main-tutor-detail.styl?vue&type=style&index=0&id=2cab827f&lang=styl&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cab827f",
  null
  
)

export default component.exports